import { render } from "./switch-table.vue?vue&type=template&id=4336fb73&scoped=true&ts=true"
import script from "./switch-table.vue?vue&type=script&lang=ts"
export * from "./switch-table.vue?vue&type=script&lang=ts"

import "./switch-table.vue?vue&type=style&index=0&id=4336fb73&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4336fb73"]])

export default __exports__